<template>
    <div>
        <label v-if="label" class="form-field__label">
            {{ label }}
        </label>
        <div :class="searchAutocompleteClass">
            <div :class="iconClass">
                <common-icon :name="iconName" size="large"></common-icon>
            </div>

            <input
                v-model="searchTerm"
                type="text"
                class="search-autocomplete__input"
                :placeholder="placeholder"
                :disabled="!!selectedUser"
                @keyup="inputChange"
                @focus="inputFocus"
                @blur="inputBlur"
            />

            <div v-if="!!items.length" class="search-autocomplete__suggestions">
                <div v-for="(item, index) in items" :key="index">
                    <single-item
                        :disableNetworkPlan="disableNetworkPlan"
                        :item="item"
                        @make-referral="userSelected($event)"
                    ></single-item>
                </div>
            </div>

            <common-user-label
                v-if="selectedUser"
                class="search-autocomplete__user-label"
                :user="selectedUser"
                :isDisabled="isDisabled"
                @close="removeSelectedUser()"
            ></common-user-label>
        </div>
    </div>
</template>

<script>
    import debounce from 'lodash.debounce'
    import ReferralsAPI from 'api/ReferralsAPI'
    import SingleItem from 'components/page-elements/search-autocomplete/SearchAutocompleteSingleItem'
    import config from '../../../config'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        components: {
            SingleItem,
        },

        props: {
            placeholder: { type: String, required: true },
            label: { type: String, required: false, default: '' },
            user: { type: Object, default: null },
            disableNetworkPlan: { type: Boolean, default: false },
            icon: { type: String, default: 'member' },
            iconPosition: { type: String, default: 'left' },
            iconBackground: { type: String, default: 'secondary' },
            practiceType: { type: String, default: PracticeTypeEnum.PHYSICIAN },
            isDisabled: { type: Boolean, default: false },
        },

        data() {
            return {
                searchTerm: '',
                items: [],
                selectedUser: null,
                isFocused: false,
            }
        },

        computed: {
            searchAutocompleteClass() {
                return {
                    [`search-autocomplete__search-input--${this.iconPosition}`]: true,
                    'search-autocomplete__search-input': true,
                    'form-input-text': true,
                }
            },

            iconName() {
                if (this.iconBackground === 'primary' && this.isFocused) return `${this.icon}-white`
                return `${this.icon}-gray`
            },

            iconClass() {
                return {
                    'search-autocomplete__icon': true,
                    [`search-autocomplete__icon--${this.iconPosition}`]: true,
                    [`search-autocomplete__icon--color-${this.iconBackground}`]: this.isFocused,
                }
            },
        },

        methods: {
            inputChange: debounce(function () {
                this.emitEvent({ name: 'input-change' })
                if (this.searchTerm.length >= 2) {
                    ReferralsAPI.getMatchesFromNetwork(
                        this.$auth.getActiveMember()?.id ? this.$auth.getActiveMember()?.id : this.$auth.getUser().id,
                        this.searchTerm,
                        this.practiceType,
                        4,
                    ).then((val) => {
                        if (val.length > 0) {
                            this.items = val
                        } else {
                            this.items = []
                            this.emitEvent({ name: 'no-results', payload: { searchTerm: this.searchTerm } })
                        }
                    })
                } else {
                    this.items = []
                }
            }, config.DEBOUNCE.DEFAULT),

            userSelected(event) {
                this.searchTerm = ''
                this.items = []
                this.selectedUser = event
                this.emitEvent({ name: 'user-select', payload: event })
            },

            removeSelectedUser() {
                this.selectedUser = null
                this.emitEvent({ name: 'user-select', payload: null })
            },

            inputFocus() {
                this.isFocused = true
            },

            inputBlur() {
                this.isFocused = false
            },
        },

        mounted() {
            this.selectedUser = this.user
        },
    }
</script>
